class RecentlyViewedProductsSection extends HTMLElement {
  #cache = {};
  #ctrl = null;

  connectedCallback() {
    // Lazy load on viewport visibility
    const obs = new IntersectionObserver(([e], o) => {
      if (e.isIntersecting) {
        o.disconnect();
        this.#load();
      }
    }, { rootMargin: '0px 0px 400px' });
    obs.observe(this);

    // Reload on meaningful attribute changes only
    const mut = new MutationObserver(m => {
      if (m.some(({ attributeName: a }) => a && a !== 'data-loaded' && a !== 'class')) {
        this.#cache = {}; // Clear cache on settings change
        this.#load();
      }
    });
    mut.observe(this, { attributes: true, attributeFilter: ['data-section-settings', 'data-product-settings'] });
  }

  async #load() {
    const q = this.#buildQuery();
    if (!q || this.dataset.loaded) return;

    try {
      const sid = this.dataset.sectionId;
      const url = `${window.routes?.searchUrl||'/search'}?section_id=${sid}&type=product&q=${encodeURIComponent(q)}`;
      
      const html = await this.#fetch(url);
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const content = doc.querySelector('.section');
      
      if (!content?.innerHTML.trim()) throw new Error('Empty');
      
      // Filter current product from DOM
      const { productId } = JSON.parse(this.dataset.productSettings || '{}');
      if (productId) {
        const products = content.querySelectorAll('[data-product-id]');
        products.forEach(p => {
          if (p.getAttribute('data-product-id') == productId) p.remove();
        });
        
        // Check if any products remain
        if (!content.querySelector('.resource-list__item')) throw new Error('No products');
      }
      
      this.dataset.loaded = 'true';
      
      // Preserve background, replace content
      const bg = this.querySelector('.section-background');
      this.innerHTML = content.outerHTML;
      if (bg) this.insertBefore(bg, this.firstChild);
      
      // Show section
      const sec = this.querySelector('.section');
      if (sec) sec.style.display = 'grid';
      
      // Init color swatches if available
      if (typeof ProductItemColorSwatch !== 'undefined') {
        try { new ProductItemColorSwatch(this); } catch {}
      }
    } catch {
      this.classList.add('hidden');
    }
  }

  async #fetch(url) {
    if (this.#cache[url]) return this.#cache[url];
    
    // Abort previous request
    this.#ctrl?.abort();
    this.#ctrl = new AbortController();

    const res = await fetch(url, { 
      credentials: 'same-origin',
      signal: this.#ctrl.signal 
    });
    
    if (!res.ok) throw new Error(res.status);
    
    return this.#cache[url] = await res.text();
  }

  #buildQuery() {
    try {
      const { productId } = JSON.parse(this.dataset.productSettings || '{}');
      const ids = JSON.parse(localStorage.getItem('viewedProducts') || '[]');
      
      // Filter current product and limit to 12
      const filtered = ids.filter(id => String(id) !== String(productId)).slice(0, 12);
      
      return filtered.map(id => `id:${id}`).join(' OR ');
    } catch {
      return '';
    }
  }
}

customElements.get('recently-viewed-products') || 
  customElements.define('recently-viewed-products', RecentlyViewedProductsSection);